import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const paymentExtension: IMcAppType = {
  name: "paymentExtension_SAP",
  path: "/my-account/payment-extension",
  description: "Request a payment extension",
  parameters: {
    required: ["caid"],
    properties: { caid: CommonParameters.caid },
  },
  navFlow: NavFlow.FOCUS,
  title: "Payment extension",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentExtension",
    customerType: CustomerType.sap,
  },
};

export const paymentExtension_KRAKEN: IMcAppType = {
  name: "paymentExtension_KRAKEN",
  path: "/my/payment-extension/:accountNumber?",
  description: "Request a payment extension",
  parameters: {
    required: ["accountNumber"],
    properties: {
      accountNumber: CommonParameters.accountNumber,
    },
  },
  navFlow: NavFlow.FOCUS,
  title: "Payment extension",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentExtension",
    customerType: CustomerType.kraken,
  },
};
